import { render, staticRenderFns } from "./ThirdPartyTabModal.vue?vue&type=template&id=18ef8322&scoped=true&"
import script from "./ThirdPartyTabModal.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyTabModal.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartyTabModal.vue?vue&type=style&index=0&id=18ef8322&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef8322",
  null
  
)

export default component.exports